import React, { useEffect, useState } from 'react';
import {gql, useMutation,useQuery} from "@apollo/client";
import Logo from '../logo.jpg';
import ImgFondo from '../campofruver-blanco-y-negro-1.png'
const GET_FRASE = gql `
query getFrases{
  getFrases{
    _id
  frase
  autor
  } 
}`


function MonitorCliente() {
  const [carrito, setCarrito] = useState([]);
  const [total, setTotal] = useState(0);

  const {loading, error, data} = useQuery(GET_FRASE);
  

  // Función para cargar el carrito desde localStorage
  const cargarCarrito = () => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarrito(carritoGuardado);
  };

  // Efecto para cargar el carrito al montar el componente y actualizarlo cada segundo
  useEffect(() => {
    cargarCarrito();
    
    const interval = setInterval(() => {
      cargarCarrito();
    }, 1000); // Verificar cada 1 segundo

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar
  }, []);

  // Efecto para recalcular el total cuando cambia el carrito
  useEffect(() => {
    recalcularTotal();
  }, [carrito]);

  // Función para recalcular el total del carrito
  const recalcularTotal = () => {
    const nuevoTotal = carrito.reduce((acc, producto) => {
      const precioAjustado = producto.codigo === "1" ? producto.precio * producto.cantidad + 200 : producto.precio * producto.cantidad;
      return acc + precioAjustado;
    }, 0);
    setTotal(nuevoTotal);
  };

  const ultimoProducto = carrito[carrito.length - 1];

       
  if(loading) return <p>Esperando resultados...</p>;
  if(error) return <p>Error</p>;

  const reversedFrases = data.getFrases.slice().reverse();

  return (
    <div className=''>
      <div className='card card-fin-compra'>
        {ultimoProducto ? (
          <div>
            <div className="container img-fondo">
              <div className="row">
                <div className="col order-last">
                  {carrito.length > 0 && (
                    <>
                      <h2>Total a pagar:</h2>
                      <p className='total'>${total.toFixed(0)}</p>
                    </>
                  )}
                </div>
                <div className="col">
                  <img className='imagen-fin-compra' src={ultimoProducto.imagen} width="200px" alt="" />
                </div>
              </div>
            </div>
            <div className='card card-fin-compra'>
              <h3> &nbsp;&nbsp;{ultimoProducto.nombre}</h3>
              {ultimoProducto.codigo !== "1" && (
                <h3>&nbsp;&nbsp;Precio: {ultimoProducto.precio}</h3>
              )}
              <h3 >&nbsp;&nbsp;Cantidad: {ultimoProducto.cantidad}</h3>
              <h3>&nbsp;&nbsp;Subtotal: ${(ultimoProducto.codigo === "1" ? (ultimoProducto.precio * ultimoProducto.cantidad + 200) : (ultimoProducto.precio * ultimoProducto.cantidad)).toFixed(0)}</h3>
            </div>
          </div>
        ) : (
          <div  className='monitor-cliente '>
             <p className='total'>Bienvenido</p>

{reversedFrases.map((frase)=>(
  <>
  <div className='frase '>
  <h1>{frase.frase}</h1>

 <p>{frase.autor}</p>
 <img className="img-fondo-cliente"  src={ImgFondo}alt="" />
  </div>
 </>
))}
          </div>
        )}
      </div>
      <ul>
        {carrito.slice().reverse().map((producto, index) => (
          <li key={index}>
            {producto.nombre}
            {producto.codigo !== "1" && (
              <> - Precio: ${producto.precio}</>
            )}
            - Subtotal: ${(producto.codigo === "1" ? (producto.precio * producto.cantidad + 200) : (producto.precio * producto.cantidad)).toFixed(0)}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default MonitorCliente;
